<div class="divider">
  <span class="divider__line"></span>
  <div class="divider__content">
    <ng-content></ng-content>
  </div>
  <span class="divider__line"></span>
</div>
